import { alertStatusOptions, contractorAlertTypeOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { StatusOfAlert } from "components/table/columnComponents/StatusOfAlert"

export const enterpriseAlertsTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Alerts",
    type: "select",
    name: "type",
    size: "middle",
    options: contractorAlertTypeOptions,
  },
  {
    title: "Date",
    type: "sort-date-range",
    name: "date",
    size: "middle",
  },
  {
    title: "Email",
    type: "sort-search",
    name: "email",
    size: "middle",
  },
  {
    title: "Contractor",
    type: "sort-search",
    name: "contractor_name",
    size: "middle",
  },
  {
    title: "Status",
    type: "select",
    name: "status",
    size: "middle",
    options: alertStatusOptions,
    cellComponent: StatusOfAlert,
  },
  {
    title: "Phone number",
    type: "sort-search",
    name: "phone_number",
    size: "middle",
  },
  {
    title: "Full name",
    type: "sort-search",
    name: "full_name",
    size: "middle",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address1",
    size: "middle",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
    size: "middle",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
    size: "small",
  },
  {
    title: "Thermostat S/N",
    type: "sort-search",
    name: "sn",
    size: "middle",
  },
]
